<template>
  <a-card>
    <div class="btn-group">
      <a-button type="primary" @click="create">上传名单</a-button>
      <a-button type="primary" @click="syncData">同步名单</a-button>
    </div>
    <a-alert v-if="uploadResult.failSize" banner style="margin-bottom: 20px">
      <template #message>
        导入{{ uploadResult.successSize }}条，<span style="color: red">
          有{{ uploadResult.failSize }}条失败，</span
        >请下载失败列表修改内容后重新上传，<span style="color: red;cursor:pointer;" @click="downErrTap" >下载失败列表</span>
      </template>
    </a-alert>
    <a-table
      :columns="columns"
      :dataSource="dataSource"
      :loading="loading"
      :pagination="pagination"
      :rowKey="(row) => row.id"
    >
      <span slot="status" slot-scope="text">{{
        text == 0 ? "启用" : "停用"
      }}</span>
      <span slot="action" slot-scope="row">
        <a-button type="link" size="small" @click="view(row.id)">查看</a-button>

        <template v-if="row.filepath">
          <a-button
            type="link"
            :disabled="row.status != 0"
            size="small"
            @click="addAction(row.id)"
            >新增上传</a-button
          >
          <a-button
            type="link"
            :disabled="row.status != 0"
            size="small"
            @click="updateAction(row.id)"
            >更新上传</a-button
          >
        </template>
        <template v-else>
          <a-button
            type="link"
            :disabled="row.status != 0"
            size="small"
            @click="asyncStudent(row.id)"
            >同步数据</a-button
          >
        </template>

        <a-button
          type="link"
          size="small"
          @click="updateStatus(row.id, row.status == 0 ? 1 : 0)"
        >
          {{ row.status == 0 ? "停用" : "启用" }}
        </a-button>
        <a-button
          type="link"
          size="small"
          @click="downStudentByBatchId(row.id, 0)"
        >
          下载
        </a-button>
        <a-popconfirm
          title="确认删除吗?"
          ok-text="是"
          cancel-text="否"
          @confirm="del(row.id)"
        >
          <a-button type="link" size="small">删除</a-button>
        </a-popconfirm>
      </span>
    </a-table>

    <a-modal v-model="uploadModal" title="上传名单" @ok="importStudent">
      <a-form-model ref="ruleForm" :model="fromData" :rules="rules">
        <a-form-model-item
          label="标题"
          :labelCol="{ span: 5 }"
          :wrapperCol="{ span: 17 }"
          prop="title"
        >
          <a-input v-model="fromData.title" />
        </a-form-model-item>
        <a-form-model-item
          label="离校批次"
          :labelCol="{ span: 5 }"
          :wrapperCol="{ span: 17 }"
          prop="batchCode"
        >
          <a-input v-model="fromData.batchCode" />
        </a-form-model-item>
        <a-form-model-item
          label="毕业类型"
          :labelCol="{ span: 5 }"
          :wrapperCol="{ span: 17 }"
          prop="graduateTypes"
        >
          <a-select v-model="fromData.graduateTypes" mode="multiple">
            <a-select-option
              v-for="item in gradeTypeList"
              :value="item.code"
              :key="item.code"
              >{{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>

        <ol>
          <li>
            <p>
              下载模板，并按照模板中的使用说明填写信息，<span
                style="color: red"
              >
                请勿更改表结构（如删除某行）</span
              >
            </p>
            <p><a @click="downloadTemplateFile">下载《毕业名单导入模板》</a></p>
          </li>
          <li>
            <p>请选择填写完成的excel 文档</p>
            <a-form-model-item
              :labelCol="{ span: 0 }"
              :wrapperCol="{ span: 24 }"
              prop="fileName"
            >
              <c-upload
                name="file"
                :multiple="false"
                :action="uploadFileUri"
                acceptType="excel"
                @change="handleChange"
              >
                <div v-if="fromData.fileName">
                  <a-icon type="file-excel" />
                  <a v-text="fromData.fileName"></a>
                </div>
                <a-button v-else>
                  <a-icon :type="uploadLoading ? 'loading' : 'plus'" />选择文件
                </a-button>
              </c-upload>
            </a-form-model-item>
            <p>请上传格式为xls或xlsx的文件，最大支持30M</p>
          </li>
        </ol>
      </a-form-model>
    </a-modal>
    <a-modal v-model="syncDataModal" title="同步名单" @ok="saveSyncStudent">
      <a-form-model ref="ruleSyncDataForm" :model="fromData" :rules="rules">
        <a-form-model-item
          label="标题"
          :labelCol="{ span: 5 }"
          :wrapperCol="{ span: 17 }"
          prop="title"
        >
          <a-input v-model="fromData.title" />
        </a-form-model-item>
        <a-form-model-item
          label="离校批次"
          :labelCol="{ span: 5 }"
          :wrapperCol="{ span: 17 }"
          prop="batchCode"
        >
          <a-input v-model="fromData.batchCode" />
        </a-form-model-item>
        <a-form-model-item
          label="毕业类型"
          :labelCol="{ span: 5 }"
          :wrapperCol="{ span: 17 }"
          prop="graduateTypes"
        >
          <a-select v-model="fromData.graduateTypes" mode="multiple">
            <a-select-option
              v-for="item in gradeTypeList"
              :value="item.code"
              :key="item.code"
              >{{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <a-modal v-model="uploadFileModal" title="上传" @ok="handleOk">
      <ol>
        <li>
          <p>
            下载模板，并按照模板中的使用说明填写信息，<span style="color: red">
              请勿更改表结构（如删除某行）</span
            >
          </p>
          <p><a @click="downloadTemplateFile">下载《毕业名单导入模板》</a></p>
        </li>
        <li>
          <p>请选择填写完成的excel 文档</p>
          <a-form-model
            ref="uploadExcelRuleForm"
            :model="uploadExcelFrom"
            :rules="rules0"
          >
            <a-form-model-item
              :labelCol="{ span: 0 }"
              :wrapperCol="{ span: 24 }"
              prop="fileName"
            >
              <c-upload
                name="file"
                :multiple="false"
                :action="uploadFileUri"
                acceptType="excel"
                @change="handleChange"
              >
                <div v-if="uploadExcelFrom.fileName">
                  <a-icon type="file-excel" />
                  <a v-text="uploadExcelFrom.fileName"></a>
                </div>
                <a-button v-else>
                  <a-icon :type="uploadLoading ? 'loading' : 'plus'" />选择文件
                </a-button>
              </c-upload>
            </a-form-model-item>
          </a-form-model>
          <p>请上传格式为xls或xlsx的文件，最大支持30M</p>
        </li>
      </ol>
    </a-modal>
  </a-card>
</template>

<script>
// import { format } from "date-fns";
import uploadFileUri from "@/services/uploadFileUri";
import buildUrl from "@/services/buildUrl";
import downloadTemplateFile from "@/services/downloadTemplateFile";
import downErrFile from "@/services/errorFile.js"

import {
  queryAll,
  updateStatus,
  del,
  downStudentError,
  downStudentByBatchId,
  importStudent,
  asyncStudent,
  addStudent,
  updateStudent,
} from "@/services/graduationList";
import { getTreeByCode } from "@/services/dict";

const rules = {
  title: [{ required: true, message: "请输入标题", trigger: "change" }],
  batchCode: [{ required: true, message: "请输入离校批次", trigger: "change" }],
  graduateTypes: [{ required: true, message: "请选择毕业类型", trigger: "change" }],
  fileName: [{ required: true, message: "请选择文件", trigger: "change" }],
};

const rules0 = {
  fileName: [{ required: true, message: "请选择文件", trigger: "change" }],
};

const columns = [
  {
    title: "标题",
    dataIndex: "title",
  },

  {
    title: "离校批次",
    dataIndex: "batchCode",
    // customRender: (text) => text + "次",
  },
  {
    title: "毕业类型",
    dataIndex: "graduateType",
  },
  {
    title: "上传时间",
    dataIndex: "uploadTime",
  },
  {
    title: "状态",
    dataIndex: "status",
    scopedSlots: { customRender: "status" },
  },

  {
    title: "操作",
    scopedSlots: { customRender: "action" },
    width: "360px",
  },
];

const dataSource = [];

export default {
  name: "GraduationList",
  data() {
    return {
      rules,
      rules0,
      columns: columns,
      dataSource: dataSource,
      pagination: {
        pageSize: 10,
        showTotal: (total) => `共${total}条`,
        current: 1,
        total: 0,
        onChange: (current) => this.onPageChange(current),
      },
      loading: false,
      params: {
        pageIndex: 1,
        pageSize: 10,
      },
      gradeTypeList: [],
      uploadModal: false,
      syncDataModal: false,
      uploadFileModal: false,
      buildUrl,
      uploadFileUri,
      fromData: {
        batchCode: null,
        filePath: null,
        fileName: null,
        title: null,
        type: "import",
      },
      uploadLoading:false,
      uploadExcelFrom: { fileName: null },
      fileType: "",
      batchId: undefined,
      fileInfo: {},
      uploadResult: { failSize: 0 },
    };
  },
  methods: {
    downErrTap(){
      console.log('点击我了',this.batchId,this.uploadResult.uid)
      downErrFile({batchId: this.batchId,uid: this.uploadResult.uid})
    },
    view(batchId) {
      console.log("view");
      this.$router.push("/settings/graduation-list-sub?batchId=" + batchId);
    },
    handleOk() {
      this.$refs.uploadExcelRuleForm.validate(async (valid) => {
        if (valid) {
          if (this.fileType == "add") {
            this.addStudent();
          } else {
            this.updateStudent();
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handleChange(info) {
      if (info.file.status !== "uploading") {
        this.uploadLoading = true;
        console.log(info.file, info.fileList);
      }
      if (info.file.status === "done") {
        this.uploadLoading = false;
        this.fileInfo = info.file.response.data;
        // this.fileInfo.uploadTime = format(new Date(), "yyyy-MM-dd HH:mm:ss");
        this.fileInfo.fileName = info.file.name;
        this.fromData.fileName = this.fileInfo.fileName;
        this.uploadExcelFrom.fileName = this.fileInfo.fileName;
      } else if (info.file.status === "error") {
        this.$message.error(`${info.file.name} 文件上传失败.`);
      }
    },
    create() {
      this.fromData = { graduateTypes: [], fileName: null };
      this.uploadModal = true;
    },
    syncData() {
      this.fromData = { graduateTypes: [], fileName: "" };
      this.syncDataModal = true;
    },
    loadData() {
      this.loading = true;
      queryAll(this.params).then((res) => {
        this.dataSource = res.records;
        this.loading = false;
        this.pagination.current = res.current;
        this.pagination.total = res.total;
      });
    },
    onPageChange(page) {
      this.params.pageIndex = page;
      this.loadData();
    },
    search() {
      this.onPageChange(1);
    },
    downloadTemplateFile() {
      downloadTemplateFile({
        type: "student",
        name: "graduation",
        fileName: "毕业名单",
      });
    },
    async importStudent() {
      this.$refs.ruleForm.validate(async (valid) => {
        if (valid) {
          this.fromData.filePath = this.fileInfo.filePath;
          this.fromData.fileName = this.fileInfo.fileName;
          this.fromData.uploadTime = this.fileInfo.uploadTime;
          this.fromData.type = "import";
          console.log("fileInfo", this.fileInfo);
          this.fromData.graduateType = this.fromData.graduateTypes.join(",");
          const msgContent = await importStudent(this.fromData);
          this.uploadResult = msgContent;
          if(msgContent.msg) return this.$message.error(msgContent.msg)
          this.uploadModal = false;
          this.$message.success("操作成功");
          this.search();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    async saveSyncStudent() {
      this.$refs.ruleSyncDataForm.validate(async (valid) => {
        if (valid) {
          this.fromData.filePath = null;
          this.fromData.fileName = null;
          this.fromData.uploadTime = null;
          this.fromData.type = "async";
          console.log("fileInfo", this.fileInfo);
          this.fromData.graduateType = this.fromData.graduateTypes.join(",");
          const dataMsg = await importStudent(this.fromData);
          if(dataMsg.msg){
            this.$message.error(dataMsg.msg);
          }else{
            this.syncDataModal = false;
            this.$message.success("操作成功");
            this.search();
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    async asyncStudent(batchId) {
      asyncStudent({ batchId });
      this.$message.success("正在同步，请稍后查看");
    },
    addAction(batchId) {
      this.uploadFileModal = true;
      this.fileType = "add";
      this.batchId = batchId;
      this.uploadExcelFrom.fileName= null;
    },
    async addStudent() {
      this.uploadResult = await addStudent({
        batchId: this.batchId,
        filePath: this.fileInfo.filePath,
        fileName: this.fileInfo.fileName,
        uploadTime: this.fileInfo.uploadTime,
      });
      if(this.uploadResult.msg) {
         this.$message.error(this.uploadResult.msg)
         return
      }
      this.uploadFileModal = false;
      if (!this.uploadResult.failSize) {
        this.$message.success("操作成功");
      } else {
        this.$message.success("操作成功");
      }
    },
    updateAction(batchId) {
      this.uploadFileModal = true;
      this.fileType = "update";
      this.batchId = batchId;
      this.uploadExcelFrom.fileName= null;
    },
    async updateStudent() {
      this.uploadResult = await updateStudent({
        batchId: this.batchId,
        filePath: this.fileInfo.filePath,
        fileName: this.fileInfo.fileName,
        uploadTime: this.fileInfo.uploadTime,
      });
      if(this.uploadResult.msg) {
         this.$message.error(this.uploadResult.msg)
         return
      }
        
      this.uploadFileModal = false;
      if (!this.uploadResult.failSize) {
        this.$message.success("操作成功");
      } else {
        this.$message.success("操作成功");
      }
    },
    async updateStatus(id, status) {
      await updateStatus({ id, status });
      this.$message.success("操作成功");
      this.search();
    },
    async del(batchId) {
      await del({ batchId });
      this.$message.success("操作成功");
      this.search();
    },
    downStudentError(batchId) {
      downStudentError("?batchId=" + batchId);
    },
    downStudentByBatchId(batchId) {
      downStudentByBatchId("?batchId=" + batchId);
    },
  },
  async mounted() {
    this.loadData();
    this.gradeTypeList = await getTreeByCode("BYLX");
  },
};
</script>

<style lang="less" scoped>
</style>
